import React from "react";

import PropTypes from "prop-types";

import RbControl from "../RbControl";
import RbTextInput from "../RbTextInput";

const RbTextControl = React.forwardRef(function RbTextControl(props, ref) {
  const {
    autoComplete,
    autoFocus,
    defaultValue,
    disableUnderline,
    endAdornment,
    format,
    inputComponent,
    inputProps,
    InputProps,
    inputRef,
    margin,
    multiline,
    name,
    onChange,
    onChangeValue,
    parse,
    placeholder,
    readOnly,
    rounded,
    rows,
    rowsMax,
    startAdornment,
    type,
    value,
    ...other
  } = props;

  return (
    <RbControl
      ref={ref}
      renderComponent={(params) => (
        <RbTextInput
          {...params}
          autoComplete={autoComplete}
          autoFocus={autoFocus}
          defaultValue={defaultValue}
          disableUnderline={disableUnderline}
          endAdornment={endAdornment}
          format={format}
          inputComponent={inputComponent}
          inputProps={inputProps}
          inputRef={inputRef}
          margin={margin}
          multiline={multiline}
          name={name}
          onChange={onChange}
          onChangeValue={onChangeValue}
          parse={parse}
          placeholder={placeholder}
          readOnly={readOnly}
          rounded={rounded}
          rows={rows}
          rowsMax={rowsMax}
          startAdornment={startAdornment}
          type={type}
          value={value}
          {...InputProps}
        />
      )}
      {...other}
    />
  );
});

RbTextControl.propTypes = {
  autoComplete: PropTypes.string,
  autoFocus: PropTypes.bool,
  defaultValue: PropTypes.any,
  disableUnderline: PropTypes.bool,
  endAdornment: PropTypes.node,
  format: PropTypes.func,
  inputComponent: PropTypes.any,
  inputProps: PropTypes.object,
  InputProps: PropTypes.object,
  inputRef: PropTypes.any,
  margin: PropTypes.oneOf(["dense", "none"]),
  multiline: PropTypes.bool,
  name: PropTypes.string,
  onChange: PropTypes.func,
  onChangeValue: PropTypes.func,
  parse: PropTypes.func,
  placeholder: PropTypes.string,
  readOnly: PropTypes.bool,
  rounded: PropTypes.bool,
  rows: PropTypes.number,
  rowsMax: PropTypes.number,
  startAdornment: PropTypes.node,
  type: PropTypes.string,
  value: PropTypes.any,
};

RbTextControl.defaultProps = {
  autoComplete: undefined,
  autoFocus: undefined,
  defaultValue: undefined,
  disableUnderline: undefined,
  endAdornment: undefined,
  format: undefined,
  inputComponent: undefined,
  inputProps: undefined,
  InputProps: undefined,
  inputRef: undefined,
  margin: undefined,
  multiline: undefined,
  name: undefined,
  onChange: undefined,
  onChangeValue: undefined,
  parse: undefined,
  placeholder: undefined,
  readOnly: undefined,
  rounded: undefined,
  rows: undefined,
  rowsMax: undefined,
  startAdornment: undefined,
  type: undefined,
  value: undefined,
};

export default React.memo(RbTextControl);
